/* The Flaire — Homepage Worlds kit (Round 5). Loaded by every hw-* section; runs once. */
(function () {
  if (window.HW && window.HW.ready) return;
  var HW = (window.HW = window.HW || {});
  HW.ready = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  var LOC = { AUD: 'en-AU', USD: 'en-US', GBP: 'en-GB', CAD: 'en-CA', NZD: 'en-NZ', EUR: 'en-IE', AED: 'en-AE', SGD: 'en-SG', HKD: 'en-HK', JPY: 'ja-JP' };
  HW.money = function (cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(LOC[cur] || 'en-US', { style: 'currency', currency: cur }).format((cents || 0) / 100); }
    catch (e) { return '$' + ((cents || 0) / 100).toFixed(2); }
  };

  /* ---------- in-view helper ---------- */
  HW.inView = function (el, cb, opts) {
    if (!('IntersectionObserver' in window)) { cb(true); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { cb(e.isIntersecting, e); }); }, opts || { threshold: 0.01 });
    io.observe(el); return io;
  };

  /* ---------- reveal ---------- */
  function reveals(scope) {
    var els = (scope || document).querySelectorAll('[data-hw-reveal]:not(.is-in),.hw-rule:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { var d = +(e.target.getAttribute('data-hw-delay') || 0); setTimeout(function () { e.target.classList.add('is-in'); }, d); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  HW.reveals = reveals;

  /* ---------- lazy autoplay video: plays only while on screen, a few at a time ----------
     Speed rules: a film fetches nothing until it is nearly on screen, only CAP films play at once
     (the one furthest from the middle of the screen pauses first), and on Data Saver / 2G the tiles
     stay as posters. Films never block the page: the lightbox loads the full-quality file on tap. */
  var activeV = [];
  var CAP = innerWidth < 900 ? 10 : 14; /* tile films are ~300 KB clips, so every film on screen can play */
  var saver = false; try { var cn = navigator.connection; saver = !!(cn && (cn.saveData || /(^|-)2g$/.test(cn.effectiveType || ''))); } catch (e) {}
  function dist(v) { var r = v.getBoundingClientRect(); return Math.abs(r.top + r.height / 2 - innerHeight / 2); }
  function startV(v) {
    if (!v.src) v.src = v.getAttribute('data-hw-src');
    var p = v.play(); if (p && p.catch) p.catch(function () {});
    if (activeV.indexOf(v) < 0) activeV.push(v);
    while (activeV.length > CAP) {
      var far = null, fd = -1; activeV.forEach(function (x) { if (x === v) return; var d = dist(x); if (d > fd) { fd = d; far = x; } });
      if (!far) break; far.pause(); activeV.splice(activeV.indexOf(far), 1);
    }
  }
  function stopV(v) { if (!v.paused) v.pause(); var i = activeV.indexOf(v); if (i > -1) activeV.splice(i, 1); }
  function videos(scope) {
    (scope || document).querySelectorAll('video[data-hw-src]:not([data-hw-v])').forEach(function (v) {
      v.setAttribute('data-hw-v', '1'); v.muted = true; v.setAttribute('muted', ''); v.playsInline = true;
      var trim = parseFloat(v.getAttribute('data-trim') || '0');
      if (trim > 0) v.addEventListener('timeupdate', function () { if (v.duration && v.currentTime > v.duration - trim) v.currentTime = 0.05; });
      HW.inView(v, function (on) {
        if (on) { if (saver && !v.hasAttribute('data-hw-hero')) return; startV(v); }
        else stopV(v);
      }, { rootMargin: '60px 0px', threshold: 0.2 });
    });
  }
  HW.videos = videos;

  /* ---------- pinned scroll progress: fn(p 0..1) for a tall section with a sticky child ---------- */
  HW.pin = function (el, fn) {
    var q = false;
    function tick() { var r = el.getBoundingClientRect(), tot = r.height - innerHeight; var p = Math.min(1, Math.max(0, -r.top / Math.max(1, tot))); fn(p, r); }
    addEventListener('scroll', function () { if (!q) { q = true; requestAnimationFrame(function () { q = false; tick(); }); } }, { passive: true });
    addEventListener('resize', tick); tick(); return tick;
  };
  /* trim for videos the lazy helper does not manage (section-managed players) */
  HW.trim = function (v) { var t = parseFloat(v.getAttribute('data-trim') || '0'); if (t > 0 && !v._trim) { v._trim = 1; v.addEventListener('timeupdate', function () { if (v.duration && v.currentTime > v.duration - t) v.currentTime = 0.05; }); } };

  /* ---------- the walk: a pinned section whose track moves sideways with scroll.
     HW.walk(root, {track, items, map, onFrame(state)}) — state = {p, v, x, near, d[]} (d = item offset from centre in viewport widths) */
  HW.walk = function (root, o) {
    var track = o.track, items = Array.prototype.slice.call(o.items || []), map = o.map ? Array.prototype.slice.call(o.map) : [], last = 0, lastT = performance.now(), v = 0, near = -1;
    var bar = o.bar;
    function frame(p) {
      var now = performance.now(), dt = Math.max(16, now - lastT); v = 0.75 * v + 0.25 * ((p - last) / dt * 1000); last = p; lastT = now;
      var x = 0;
      if (track && o.mode !== 'none') { var dist = Math.max(0, track.scrollWidth - innerWidth); x = -p * dist; track.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)'; }
      var cw = innerWidth / 2, d = [], best = 1e9, bi = -1;
      items.forEach(function (it, k) { var b = it.getBoundingClientRect(); var c = (b.left + b.width / 2 - cw) / innerWidth; d.push(c); if (Math.abs(c) < best) { best = Math.abs(c); bi = k; } });
      if (bi !== near) { near = bi; items.forEach(function (it, k) { it.classList.toggle('is-near', k === bi); }); map.forEach(function (m, k) { m.classList.toggle('on', k === bi); }); if (o.onNear) o.onNear(bi); }
      if (bar) bar.style.width = (p * 100).toFixed(1) + '%';
      if (o.onFrame) o.onFrame({ p: p, v: v, x: x, near: near, d: d });
    }
    var tick = HW.pin(root, frame);
    // keep physics alive (velocity decays) even when scroll stops
    (function idle() { if (Math.abs(v) > 0.0005) { v *= 0.9; if (o.onFrame) o.onFrame({ p: last, v: v, x: null, near: near, d: null }); } requestAnimationFrame(idle); })();
    map.forEach(function (m, k) { m.addEventListener('click', function () { var r = root.getBoundingClientRect(), tot = r.height - innerHeight; var target = (k + (o.offset || 1)) / Math.max(1, items.length - 1 + (o.offset || 1)); scrollTo({ top: scrollY + r.top + tot * Math.min(1, k / Math.max(1, items.length - 1)), behavior: 'smooth' }); }); });
    return tick;
  };

  /* ---------- the moving rail: glides on its own, drag/swipe with momentum ---------- */
  HW.rail = function (el, o) {
    if (!el || el._hw) return; el._hw = 1; o = o || {};
    var track = el.querySelector('.hw-rail__track'); if (!track) return;
    var speed = +(o.speed || el.getAttribute('data-speed') || 26); // px per second
    var dir = (o.dir || el.getAttribute('data-dir') || 'left') === 'right' ? 1 : -1;
    var kids = Array.prototype.slice.call(track.children); if (!kids.length) return;
    var first = kids[0];
    // clone one full set so we can measure the loop, then keep cloning until the lane is covered
    function cloneSet() { kids.forEach(function (k) { var c = k.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.setAttribute('tabindex', '-1'); c.querySelectorAll('a,button').forEach(function (a) { a.setAttribute('tabindex', '-1'); }); track.appendChild(c); }); }
    cloneSet();
    function fixClones() { Array.prototype.slice.call(track.children, kids.length).forEach(function (c) { c.querySelectorAll('video').forEach(function (vv) { vv.removeAttribute('data-hw-v'); vv.removeAttribute('src'); }); }); }
    var loopW = track.children[kids.length].offsetLeft - first.offsetLeft;
    if (!(loopW > 10) || !el.offsetParent) { while (track.children.length > kids.length) track.removeChild(track.lastChild); el._hw = 0; return; }
    var sets = 2; while (loopW * (sets - 1) < el.clientWidth * 1.6 && sets < 8) { cloneSet(); sets++; }
    fixClones(); if (HW.videos) HW.videos(track);
    var x = dir > 0 ? -loopW : 0, v = 0, drag = false, down = false, sx = 0, sy = 0, x0 = 0, lastX = 0, lastT = 0, moved = 0, idleUntil = 0, visible = true, hover = false, cur = speed, decided = false;
    function wrap() { while (x <= -loopW) x += loopW; while (x > 0) x -= loopW; }
    function frame(t) {
      if (!frame.t) frame.t = t; var dt = Math.min(0.05, (t - frame.t) / 1000); frame.t = t;
      if (visible && !drag) {
        var target = (hover || t < idleUntil || reduce) ? 0 : speed;
        cur += (target - cur) * Math.min(1, dt * 3);
        if (Math.abs(v) > 0.5) { x += v * dt; v *= Math.pow(0.04, dt); } else v = 0;
        x += dir * cur * dt; wrap();
        track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
    HW.inView(el, function (on) { visible = on; }, { threshold: 0 });
    el.addEventListener('mouseenter', function () { hover = true; });
    el.addEventListener('mouseleave', function () { hover = false; });
    el.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button > 0) return;
      down = true; decided = false; drag = false; sx = e.clientX; sy = e.clientY; x0 = x; lastX = e.clientX; lastT = performance.now(); moved = 0; v = 0;
    });
    el.addEventListener('pointermove', function (e) {
      if (!down) return; var dx = e.clientX - sx, dy = e.clientY - sy;
      if (!decided) { if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return; decided = true; if (Math.abs(dy) > Math.abs(dx)) { down = false; return; } drag = true; el.classList.add('is-drag'); try { el.setPointerCapture(e.pointerId); } catch (_) {} }
      if (!drag) return;
      var now = performance.now(); var ddx = e.clientX - lastX; var dtt = Math.max(1, now - lastT);
      v = 0.8 * v + 0.2 * (ddx / dtt * 1000); lastX = e.clientX; lastT = now;
      x = x0 + dx; moved = Math.abs(dx); wrap(); track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
      x0 = x - dx; // keep relative after wrap
    });
    function end() { if (!down && !drag) return; down = false; if (drag) { drag = false; el.classList.remove('is-drag'); idleUntil = performance.now() + 2200; } }
    el.addEventListener('pointerup', end); el.addEventListener('pointercancel', end); el.addEventListener('lostpointercapture', end);
    el.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
    el.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) { e.preventDefault(); x -= e.deltaX; wrap(); idleUntil = performance.now() + 1500; } }, { passive: false });
    el._hwNudge = function (px) { v += px * 4; idleUntil = performance.now() + 1800; };
  };
  function rails(scope) { (scope || document).querySelectorAll('.hw-rail').forEach(function (r) { HW.rail(r); }); }
  HW.rails = rails;

  /* ---------- cart: add → UpCart drawer, Buy-2-Get-1 meter from the real cart ---------- */
  HW.count = 0;
  HW.getCart = function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { HW.count = c.item_count || 0; meters(); return c; }).catch(function () {}); };
  function meters() {
    var n = HW.count, m = n % 3, free = Math.floor(n / 3);
    var msg = n === 0 ? 'Add any <b>3 pieces</b> — one is <b>free</b>, applied at checkout'
      : m === 1 ? 'Add <b>2 more</b> — one of the three is <b>free</b>'
      : m === 2 ? 'Add <b>1 more</b> and one piece is <b>free</b>'
      : '<b>' + (free > 1 ? free + ' pieces are' : 'One piece is') + ' free</b> — applied automatically';
    document.querySelectorAll('[data-hw-meter]').forEach(function (el) {
      var t = el.querySelector('[data-hw-meter-msg]'); if (t) t.innerHTML = msg;
      var c = el.querySelector('[data-hw-meter-count]'); if (c) c.textContent = n;
      var fill = n > 0 && m === 0 ? 3 : m;
      el.querySelectorAll('.hw-meter__bar i').forEach(function (i, k) { i.classList.toggle('on', k < fill); });
    });
    document.dispatchEvent(new CustomEvent('hw:cart', { detail: { count: n } }));
  }
  HW.meters = meters;
  function toast(html) {
    var t = document.querySelector('.hw-toast'); if (!t) { t = document.createElement('div'); t.className = 'hw-toast'; document.body.appendChild(t); }
    t.innerHTML = html; t.classList.add('show'); clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }
  HW.toast = toast;
  HW.add = function (variantId, qty) {
    var base; try { base = window.upcartShouldSkipAddToCartInterceptor; window.upcartShouldSkipAddToCartInterceptor = true; } catch (e) {}
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return fetch(url + (url.indexOf('.js') > -1 ? '' : '.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] }) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        try { window.upcartShouldSkipAddToCartInterceptor = base; } catch (e) {}
        if (res && res.status && res.description) { toast(res.description); throw res; }
        return HW.getCart().then(function () {
          var p; try { if (typeof window.upcartRefreshCart === 'function') p = window.upcartRefreshCart(); } catch (e) {}
          return Promise.resolve(p).then(function () {
            try { if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); return; } } catch (e) {}
            try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
            toast('Added to your bag');
          });
        });
      });
  };

  /* ---------- quick-buy sheet ---------- */
  var sheet, state;
  function buildSheet() {
    sheet = document.createElement('div'); sheet.className = 'hw hw-qb'; sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true');
    sheet.innerHTML = '<div class="hw-qb__scrim" data-x></div><div class="hw-qb__panel"><button class="hw-qb__x" data-x aria-label="Close">&times;</button><div class="hw-qb__top"><img alt=""><div><div class="hw-qb__t"></div><div class="hw-price hw-qb__p"></div></div></div><div class="hw-qb__opts"></div><button class="hw-btn hw-btn--block hw-qb__go">Add to bag</button><div class="hw-qb__note"></div><a class="hw-qb__full" href="#">See every detail &rarr;</a></div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', function (e) { if (e.target.hasAttribute('data-x')) closeSheet(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
    sheet.querySelector('.hw-qb__go').addEventListener('click', function () {
      var v = current(); if (!v || !v.available) return; var b = this; b.textContent = 'Adding…';
      HW.add(v.id).then(function () { b.textContent = 'Add to bag'; closeSheet(); }).catch(function () { b.textContent = 'Add to bag'; });
    });
  }
  function current() { if (!state) return null; return state.p.variants.filter(function (v) { return v.options.every(function (o, i) { return o === state.sel[i]; }); })[0]; }
  function paint() {
    var p = state.p, v = current();
    sheet.querySelector('.hw-qb__opts').innerHTML = p.options.map(function (o, i) {
      if (p.options.length === 1 && o.values.length === 1) return '';
      return '<div class="hw-qb__opt">' + o.name + ' &middot; <span style="color:#f3eee4;letter-spacing:.06em">' + state.sel[i] + '</span></div><div class="hw-qb__pills">' + o.values.map(function (val) {
        var ok = p.variants.some(function (vv) { return vv.available && vv.options[i] === val && vv.options.every(function (x, j) { return j === i || x === state.sel[j]; }); });
        return '<button data-i="' + i + '" data-v="' + String(val).replace(/"/g, '&quot;') + '" class="' + (state.sel[i] === val ? 'on' : '') + '"' + (ok ? '' : ' disabled') + '>' + val + '</button>';
      }).join('') + '</div>';
    }).join('');
    sheet.querySelectorAll('.hw-qb__pills button').forEach(function (b) { b.onclick = function () { state.sel[+b.dataset.i] = b.dataset.v; paint(); }; });
    var price = v ? v.price : p.price, cmp = v ? v.compare_at_price : p.compare_at_price;
    sheet.querySelector('.hw-qb__p').innerHTML = (cmp && cmp > price ? '<s>' + HW.money(cmp) + '</s>' : '') + '<b>' + HW.money(price) + '</b>';
    var img = (v && v.featured_image && v.featured_image.src) || p.featured_image; if (img) sheet.querySelector('img').src = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
    var go = sheet.querySelector('.hw-qb__go'); go.disabled = !(v && v.available); go.textContent = v && v.available ? 'Add to bag — ' + HW.money(price) : 'Sold out in this choice';
    var n = HW.count, m = (n + 1) % 3;
    sheet.querySelector('.hw-qb__note').innerHTML = m === 0 ? 'This makes 3 — <b style="color:#f3d792;font-weight:500">one piece is free</b> at checkout' : 'Buy 2, get 1 free — no code needed';
  }
  function openSheet(p) {
    if (!sheet) buildSheet();
    var firstAvail = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    state = { p: p, sel: firstAvail.options.slice() };
    sheet.querySelector('.hw-qb__t').textContent = p.title; sheet.querySelector('.hw-qb__full').href = '/products/' + p.handle;
    paint(); sheet.classList.add('open'); requestAnimationFrame(function () { requestAnimationFrame(function () { sheet.classList.add('show'); }); });
  }
  function closeSheet() { if (!sheet) return; sheet.classList.remove('show'); setTimeout(function () { sheet.classList.remove('open'); }, 420); }
  HW.quick = function (handle) {
    return fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var avail = p.variants.filter(function (v) { return v.available; });
      if (p.variants.length === 1 && avail.length) return HW.add(avail[0].id);
      openSheet(p);
    });
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hw-add]'); if (!b) return;
    e.preventDefault(); b.classList.add('is-busy'); HW.quick(b.getAttribute('data-hw-add')).then(function () { b.classList.remove('is-busy'); }, function () { b.classList.remove('is-busy'); });
  });

  /* ---------- film lightbox: full-screen film + the exact pieces in it, each one tap to add ---------- */
  var lb;
  HW.openFilm = function (o) {
    if (!lb) {
      lb = document.createElement('div'); lb.className = 'hw hw-lb';
      lb.innerHTML = '<div class="hw-lb__scrim" data-x></div><div class="hw-lb__box"><button class="hw-lb__x" data-x aria-label="Close">&times;</button><div class="hw-lb__v"><video muted loop playsinline></video><button class="hw-lb__snd" type="button" aria-label="Sound">&#128263;</button></div><div class="hw-lb__side"><span class="hw-eyebrow">In this film</span><div class="hw-lb__list"></div><div class="hw-meter" data-hw-meter><div class="hw-meter__row"><span data-hw-meter-msg></span></div><div class="hw-meter__bar"><i></i><i></i><i></i></div></div></div></div>';
      document.body.appendChild(lb);
      lb.addEventListener('click', function (e) { if (e.target.hasAttribute('data-x')) closeLb(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });
      var snd = lb.querySelector('.hw-lb__snd'); snd.onclick = function () { var v = lb.querySelector('video'); v.muted = !v.muted; snd.innerHTML = v.muted ? '&#128263;' : '&#128266;'; };
      HW.trim(lb.querySelector('video'));
    }
    var v = lb.querySelector('video'); v.setAttribute('data-trim', o.trim || 1.6); v.poster = o.poster || ''; v.src = o.url; v.muted = true; lb.querySelector('.hw-lb__snd').innerHTML = '&#128263;';
    var list = lb.querySelector('.hw-lb__list'); list.innerHTML = '';
    (o.p || []).forEach(function (h) {
      var row = document.createElement('div'); row.className = 'hw-lb__row'; row.innerHTML = '<span class="hw-lb__ph"></span><span class="hw-lb__t">…</span><button type="button" class="hw-btn hw-btn--sm" data-hw-add="' + h + '">Add</button>'; list.appendChild(row);
      fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (pr) {
        row.querySelector('.hw-lb__t').innerHTML = '<a href="/products/' + pr.handle + '">' + pr.title + '</a><b>' + HW.money(pr.price) + (pr.compare_at_price > pr.price ? ' <s>' + HW.money(pr.compare_at_price) + '</s>' : '') + '</b>';
        if (pr.featured_image) row.querySelector('.hw-lb__ph').innerHTML = '<img src="' + pr.featured_image + (pr.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="">';
      }).catch(function () { row.remove(); });
    });
    lb.classList.add('open'); HW.meters(); requestAnimationFrame(function () { lb.classList.add('show'); var pr = v.play(); pr && pr.catch && pr.catch(function () {}); });
  };
  function closeLb() { if (!lb) return; lb.classList.remove('show'); var v = lb.querySelector('video'); v.pause(); setTimeout(function () { lb.classList.remove('open'); }, 350); }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-hw-film]'); if (!t || e.target.closest('[data-hw-add]')) return;
    e.preventDefault(); try { HW.openFilm(JSON.parse(t.getAttribute('data-hw-film'))); } catch (err) {}
  });

  /* ---------- the bag dock: appears after the first screen, follows the real cart ---------- */
  function dock() {
    var d = document.querySelector('.hx-dock'); if (!d) return;
    var show = false;
    var pins = document.querySelectorAll('.hw-walk,.hx-ub--scrub,.hx-cin');
    function inPin() { for (var i = 0; i < pins.length; i++) { var r = pins[i].getBoundingClientRect(); if (r.top < innerHeight * 0.4 && r.bottom > innerHeight * 0.75) return true; } return false; }
    /* the bar steps aside while you scroll down (so it never sits on what you are reading)
       and returns when you pause or scroll back up */
    var lastY = scrollY, goingDown = false, idleT;
    function upd() {
      var y = scrollY; if (Math.abs(y - lastY) > 6) { goingDown = y > lastY; lastY = y; }
      clearTimeout(idleT); idleT = setTimeout(function () { goingDown = false; upd2(); }, 900);
      upd2();
    }
    function upd2() { var on = scrollY > innerHeight * 0.9 && scrollY < document.documentElement.scrollHeight - innerHeight * 1.6 && !inPin() && !goingDown; if (on !== show) { show = on; d.classList.toggle('on', on); } }
    addEventListener('scroll', upd, { passive: true }); upd2();
    d.querySelector('[data-dock-open]').addEventListener('click', function () { try { if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); return; } } catch (e) {} location.href = '/cart'; });
    document.addEventListener('hw:cart', function (ev) { var n = ev.detail.count; d.querySelector('[data-dock-n]').textContent = n; d.classList.toggle('has', n > 0); });
  }

  /* ---------- the height of his sticky header stack, so pinned scenes sit below it ---------- */
  function hwTop() {
    var b = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function (e) { var r = e.getBoundingClientRect(); if (r.height > 0 && r.top > -2 && r.top < 260 && r.bottom > b) b = r.bottom; });
    if (b > 0) document.documentElement.style.setProperty('--hwtop', Math.round(b) + 'px');
  }
  HW.hwTop = hwTop;

  /* ---------- boot ---------- */
  function boot() {
    hwTop(); addEventListener('resize', hwTop); setTimeout(hwTop, 1200); dock();
    var q = window.HWQ || []; window.HWQ = { push: function (f) { try { f(); } catch (e) { console.error(e); } } };
    q.forEach(function (f) { try { f(); } catch (e) { console.error(e); } });
    reveals(); videos(); rails(); HW.getCart();
    document.addEventListener('shopify:section:load', function (e) { reveals(e.target); videos(e.target); rails(e.target); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
